var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Lección #1","audio2":"../mp3/SecundariaA/01SA.mp3","cover":"../img/8.jpg","name":"Secundaria A"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }